import React from 'react';
import { useIntl } from 'react-intl';

import { useNetworkName } from 'hooks/kitchenSink';
import classNames from 'classnames';
import { ChannelKey } from 'app-types';

import styles from './EventTitle.module.scss';

const messages = {
  dot: {
    id: 'common.dot',
    description: 'dot',
  },
};

interface EventTitleProps {
  prefix?: string | null;
  title?: string | null;
  brand?: ChannelKey | null;
  shouldScroll?: boolean;
}

// Rules:
// Ticker only needs to occur on content with a network logo underneath
// It style will not occur on titles that span more than one line
//
const EventTitle: React.FC<EventTitleProps> = ({
  prefix = null,
  title = null,
  brand = null,
}) => {
  const intl = useIntl();
  const networkName = useNetworkName(brand as ChannelKey);

  const headerEl = prefix ? (
    <>
      <span className={styles.prefix}>{prefix}</span>
      <span>
        {' '}
        {intl.formatMessage(messages.dot)} {networkName}
      </span>
    </>
  ) : (
    networkName
  );

  return (
    <div data-testid="tile-title">
      <div className={classNames('text-truncate', styles.header)}>
        {headerEl}
      </div>
      <div className={classNames('text-truncate', styles.title)}>{title}</div>
      {/* {shouldScroll ? (
        <TickerText>{title}</TickerText>
      ) : (
        <div className="text-truncate">{title}</div>
      )} */}
    </div>
  );
};

export default EventTitle;
